import React from 'react'

import { withTranslation as translate } from 'react-i18next'
import Error from './Error'

const codeErrorKey = (code) =>
  code.includes('promotion_already_used')
    ? 'signup.profile.error.service_code.already_used'
    : 'signup.profile.error.service_code.invalid'

const PromotionOrReferrerCode = ({ value, onChange, t, errors }) => {
  // force codes to be uppercase when submitted
  const onFocusOut = (e) => {
    e.target.value = e.target.value.toUpperCase()
    // ensure change is added to state
    onChange(e)
  }

  return (
    <div>
      <input
        name='ref_code'
        className={errors.code ? 'error' : ''}
        type='text'
        value={value}
        onChange={onChange} onBlur={onFocusOut}
        placeholder={t('signup.quote.product_code')}
      />
      {errors.code && <Error messageKey={codeErrorKey(errors.code)} />}
    </div>
  )
}

export default translate()(PromotionOrReferrerCode)
